import { CommandBar, DefaultButton, DocumentCard, DocumentCardDetails, DocumentCardPreview, DocumentCardTitle, DocumentCardType, getFocusStyle, getTheme, IBasePickerProps, IBasePickerSuggestionsProps, IButtonProps, ICommandBarItemProps, ICommandBarStyles, Icon, IDocumentCardPreviewProps, IDocumentCardStyles, IDropdownOption, IMessageBarProps, IPanelStyles, ITheme, List, mergeStyleSets, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, ValidationState } from '@fluentui/react';
import { getFileTypeIconProps } from '@fluentui/react-file-type-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios, { CancelTokenSource } from 'axios';
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { store } from '../../../..';
import { myTheme } from '../../../../assets/styles/my-theme';
import protocolsService from '../../../../services/protocols.service';
import { IDestinatarioProtocollo, IField, IAttachmentPecMail, ISendMailRequest } from '../../../../shared/interfaces';
import AppUtilities from '../../../../shared/Utilities/appUtilities';
import { reduxActions, RootState } from '../../../../store';
import CustomCommandBarButton from '../../../CustomFluentUI/CustomCommandBarButton/CustomCommandBarButton';
import CustomCommandBarMenuItem from '../../../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';
import IndicePAPanel from '../../../IndicePA/IndicePAPanel';
import RubricaPanel from '../../../Rubrica/RubricaPanel';
import SendMailForm from './SendMailForm';
import abilityBuild from '../../../../shared/CASL/appAbility';
import { subject, Unsubscribe } from "@casl/ability";
import Utilities from '../../../../shared/Utilities/utilities';
import CircleLoader from '../../../Loader/CircleLoader/CircleLoader';
import { toastRef } from '../../../Layout/Layout';
import { SendMailState } from '../../../../store/send-mail/types';

const emailRegex = Utilities.GetRegexIndirizziEmailSeparatiDaPuntoEVirgola();

const queryString = require('query-string');

const panelStyles: Partial<IPanelStyles> = {
    content: {
        padding: '24px 20px 0px',
        display: 'flex',
        flexFlow: 'column',
        overflow: 'hidden',
    },
    scrollableContent: {
        display: 'flex',
        flexFlow: 'column',
        overflow: 'hidden',
    }
}

const documentCardSyles: Partial<IDocumentCardStyles> = {
    root: {
        height: 65,
        maxWidth: 'unset !important'
    }
}

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee', borderTop: '1px solid #eee' },
    secondarySet: {
        '& .ms-OverflowSet-item': {
            display: 'flex', flexFlow: 'row', justifyContent: 'center', padding: '4px'
        }
    }
};

const theme: ITheme = getTheme();
const { semanticColors, fonts } = theme;
const { palette } = myTheme;

const classNames = mergeStyleSets({
    itemCell: [
        getFocusStyle(theme, { inset: -1 }),
        {
            minHeight: 54,
            padding: 10,
            boxSizing: 'border-box',
            borderBottom: `1px solid ${semanticColors.bodyDivider}`,
            display: 'flex',
            selectors: {
                '&:hover': { background: palette.neutralLight },
            },
        },
    ],
    itemImage: {
        flexShrink: 0,
    },
    itemContent: {
        marginLeft: 10,
        overflow: 'hidden',
        flexGrow: 1,
    },
    itemName: [
        fonts.medium,
        {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    ],
    itemDimension: {
        fontSize: fonts.small.fontSize,
        color: palette.neutralTertiary,
        marginBottom: 10,
        padding: '0px 16px'
    },
    chevron: {
        alignSelf: 'center',
        marginLeft: 10,
        color: palette.neutralTertiary,
        fontSize: fonts.large.fontSize,
        flexShrink: 0,
    },
});



const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentProtocol: state.appNavigationReducer.protocol,
    sendMailFields: state.sendMailReducer.sendMailFields,
})

const mapDispatch = {
    setSendMailInitialState: () => (reduxActions.sendMailActions.setInitialState()),
    updateSendMailState: (newState: Partial<SendMailState>) => (reduxActions.sendMailActions.updateState(newState))

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface SendMailPanelProps {
    loading?: boolean
    extraCssClass?: string
    sendMailPanelIsOpen: boolean
    onSendMail: (mail: ISendMailRequest) => void
    onDismiss: () => void
}

type Props = SendMailPanelProps & RouteComponentProps & PropsFromRedux

export interface SendMailPanelState {
    loading: boolean
    panelIsOpen: boolean
    mailAttachments: any[]
    messageBarIsVisible: boolean
    messageBarProps: IMessageBarProps
    commandBarItems: ICommandBarItemProps[]
    indicePAPanelIsOpen: boolean
    rubricaPanelIsOpen: boolean
}

class SendMailPanel extends React.Component<Props, SendMailPanelState> {
    cancelTokenSources = {};
    attachmentsGetBase64Requests = {};
    unsubscribeFromAbility: Unsubscribe = () => { };

    constructor(props) {
        super(props);
        this.state = {
            loading: this.props.loading ?? false,
            panelIsOpen: this.props.sendMailPanelIsOpen,
            mailAttachments: [] as any[],
            messageBarIsVisible: false,
            messageBarProps: {
                dismissButtonAriaLabel: "Close",
                messageBarType: MessageBarType.error,
                children: ''
            },
            commandBarItems: [] as ICommandBarItemProps[],
            indicePAPanelIsOpen: false,
            rubricaPanelIsOpen: false,
        }
    }



    componentDidMount() {

        this.setCommandBar();

        this.setMailAttachments();


    }

    componentWillUnmount() {
        // Cancella tutte le request in pending
        for (const [key, value] of Object.entries<CancelTokenSource>(this.cancelTokenSources)) {
            value.cancel(`${key} canceled`)
        }
        this.unsubscribeFromAbility();

    }

    componentDidUpdate(prevProps: Props, prevState: any) {
        if (prevProps.sendMailPanelIsOpen !== this.props.sendMailPanelIsOpen) {
            this.setState({ panelIsOpen: this.props.sendMailPanelIsOpen });
        }

        if (prevProps.currentProtocol?.protocolId !== this.props.currentProtocol?.protocolId || prevProps.sendMailPanelIsOpen !== this.props.sendMailPanelIsOpen) {
            this.setMailAttachments();
        }
    }


    setMailAttachments = () => {
        let { currentProtocol, currentAoo } = this.props;
        if (currentProtocol && currentAoo) {
            const parsedQueryString = queryString.parse(this.props.location.search);
            const uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

            // Helper: File -> base64 (senza prefisso data)
            const fileToBase64 = (file: File): Promise<string> =>
                new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onerror = () => reject(new Error('File read error'));
                    reader.onload = () => {
                        const result = (reader.result as string) || '';
                        resolve(result.includes(',') ? result.split(',')[1] : result);
                    };
                    reader.readAsDataURL(file);
                });

            this.attachmentsGetBase64Requests = {};

            // Documento principale
            let { docBase64String, ...documentNoBase64 } = currentProtocol.documentFile!;
            let newMailAttachments: any[] = [{
                nomeFile: currentProtocol.documentFile?.fileName,
                buff: currentProtocol.documentFile?.docBase64String,
                loading: false,
                ...documentNoBase64!
            }];

            // Allegati del protocollo
            currentProtocol.attachments?.forEach((el, index) => {
                let { docBase64String, ...attachmentNoBase64 } = el;
                let fileName = el.originalName ? el.originalName : el.fileName;

                newMailAttachments.push({
                    nomeFile: fileName,
                    buff: el.docBase64String,
                    loading: true,
                    ...attachmentNoBase64
                })

                if (uorId && !el.docBase64String) {
                    this.attachmentsGetBase64Requests[index] = protocolsService.getFileById(currentAoo!.id, uorId, this.props.match.params['id'], el.id!);

                }
            });

            this.setState({ mailAttachments: [...newMailAttachments] });
            const fileReadPromises: Promise<void>[] = [];
            newMailAttachments.forEach((item) => {
                if (item.file instanceof File && !item.buff) {
                    item.loading = true;
                    fileReadPromises.push(
                        fileToBase64(item.file)
                            .then(b64 => { item.buff = b64; item.loading = false; })
                    );
                }
            });
            Promise.all(fileReadPromises).then(() => {
                this.setState({ mailAttachments: [...newMailAttachments] });
            });
            let reqArray = Object.values(this.attachmentsGetBase64Requests);
            if (reqArray && reqArray.length > 0) {
                axios.all(reqArray).then(axios.spread((...responses) => {
                    let protocolAttachments = currentProtocol!.attachments ? [...currentProtocol!.attachments] : [];

                    responses.forEach((fileResult: any) => {
                        let protocolAttachmentIndex = protocolAttachments.findIndex(el => el.fileName === fileResult.fileName);
                        if (protocolAttachmentIndex >= 0) {
                            let attachment = {
                                ...protocolAttachments[protocolAttachmentIndex],
                                buff: fileResult.docBase64String,
                                loading: false

                            }
                            protocolAttachments[protocolAttachmentIndex] = attachment;

                        }
                        let mailAttachmentIndex = newMailAttachments.findIndex(el => el.fileName === fileResult.fileName);
                        if (mailAttachmentIndex >= 0) {
                            let attachment = {
                                ...newMailAttachments[mailAttachmentIndex],
                                buff: fileResult.docBase64String,
                                loading: false

                            }
                            newMailAttachments[mailAttachmentIndex] = attachment;

                        }
                    });
                    this.setState({ mailAttachments: [...newMailAttachments] });

                    store.dispatch(reduxActions.appNavigationActions.setProtocol({ attachments: [...protocolAttachments] }));

                }));
            }

        }
    }

    setCommandBar = () => {
        let newCommandBarItems: ICommandBarItemProps[] = [];
        if (abilityBuild.can('use', subject('IFeature', { key: 'IndicePA', enabled: true }))) {

            newCommandBarItems.push({
                key: 'indicePA',
                commandBarButtonAs: () => (

                    <CustomCommandBarButton
                        text='Indice PA'
                        key='indicePA'
                        iconPropsFontAwesome={{ icon: ['far', 'filter'] }}
                        onClick={() => this.setState({ indicePAPanelIsOpen: true })}
                    />

                )
            });
        }
        if (abilityBuild.can('use', subject('IFeature', { key: 'Rubrica', enabled: true }))) {
            newCommandBarItems.push({
                key: 'rubrica',
                commandBarButtonAs: () => (
                    <CustomCommandBarButton
                        text='Rubrica'
                        key='rubrica'
                        iconPropsFontAwesome={{ icon: ['fal', 'address-book'] }}
                        onClick={() => this.setState({ rubricaPanelIsOpen: true })}
                    />
                )

            });
        }
        this.setState({ commandBarItems: [...newCommandBarItems] });

    }



    checkFormValidity = (): boolean => {
        let isValid = true;

        let errors = {};

        let newSendMailFields = { ...this.props.sendMailFields };



        Object.values(this.props.sendMailFields).forEach((field: IField, index) => {
            let newField = { ...field };
            let fieldValidity = AppUtilities.checkFieldValidity(newField)
            if (!fieldValidity) {
                isValid = false;
                errors["fields"] = "compilare correttamente tutti i campi obbligatori";
            }
            newSendMailFields[newField.internalName] = {
                ...newField,
                touched: true,
                valid: fieldValidity
            }

        });
        if (this.state.mailAttachments.some(el => el.loading)) {
            isValid = false;
            errors["attachments"] = "attendere il caricamento degli allegati";
        }


        if (isValid) {

            this.setState({ messageBarIsVisible: false });
        }
        else {
            let errorMessage = AppUtilities.getMessageFromErrorObjectValidity(errors);
            console.log(errorMessage);
            this.setState({
                messageBarIsVisible: true,
                messageBarProps: {
                    dismissButtonAriaLabel: "Close",
                    messageBarType: MessageBarType.error,
                    children: `${errorMessage}`,
                }
            });


        }
        this.props.updateSendMailState({ sendMailFields: { ...newSendMailFields } });

        return isValid;
    }


    sendMailPanelSubmit = () => {
        if (this.checkFormValidity()) {
            let { sendMailFields } = this.props;
            let { mailAttachments } = this.state;

            let destinatari: IDestinatarioProtocollo[] = sendMailFields.to.internalValue
                .map(el => el.destinatarioProtocollo);

            let cc: IDestinatarioProtocollo[] = sendMailFields.cc.internalValue
                .map(el => el.destinatarioProtocollo);

            let mail: ISendMailRequest = {
                idProtocollo: this.props.currentProtocol!.protocolId!,
                from: sendMailFields.from.internalValue,
                to: [...destinatari],
                cc: [...cc],
                attachments: mailAttachments.map(el => {
                    let allegatoMail: IAttachmentPecMail = {
                        buff: el.buff,
                        dimensione: el.dimensione,
                        id: el.id,
                        nomeFile: el.nomeFile,
                        tipologia: el.tipologia,
                        unit: el.unit,
                    }
                    return allegatoMail;
                }),
                subject: sendMailFields.subject.internalValue,
                body: sendMailFields.body.internalValue,


            };

            this.props.onSendMail(mail);
            this.resetFormFields();
        }

    }

    sendMailPanelDismiss = () => {


        this.props.onDismiss();
    }


    resetFormFields = () => {
        this.props.setSendMailInitialState();

    }

    previewPropsUsingIcon: IDocumentCardPreviewProps = {
        previewImages: [
            {
                previewIconProps: {
                    iconName: 'OpenFile',
                    styles: {
                        root: {
                            fontSize: fonts.large.fontSize,
                            color: palette.themePrimary,
                            backgroundColor: palette.neutralLighterAlt,
                        },
                    },
                },
                width: 63,
            }
        ],
        styles: {
            previewIcon: { backgroundColor: palette.neutralLighterAlt },
        },
    };


    dismissIncicePALateralPanel = () => {
        this.setState({ indicePAPanelIsOpen: false });
    }

    dismissRubricaLateralPanel = () => {
        this.setState({ rubricaPanelIsOpen: false });
    }



    attachmentRenderIcon = (item) => {
        if (item.loading) {
            return <div style={{ fontSize: 20 }}> <FontAwesomeIcon icon={['fal', 'circle-notch']} spin /></div>;
        }
        else
            return <Icon {...getFileTypeIconProps({ extension: item.extension, size: 20 })} />;

    }

    attachmentRenderCell = (item) => {
        const previewPropsUsingIcon: IDocumentCardPreviewProps = {
            previewImages: [
                {
                    previewIconProps: {
                        children: this.attachmentRenderIcon(item)
                    },
                    width: 63,

                }
            ],
            styles: {
                previewIcon: { backgroundColor: palette.neutralLighterAlt },
            },

        };
        let fileName = item.originalName ? item.originalName : item.fileName;

        return (
            <DocumentCard
                aria-label={fileName}
                type={DocumentCardType.compact}
                styles={documentCardSyles}
            >
                <DocumentCardPreview {...previewPropsUsingIcon} />
                <DocumentCardDetails>
                    <DocumentCardTitle title={fileName} className={classNames.itemName} />
                    <div className={classNames.itemDimension}>{AppUtilities.GetDimensionFileString(item)}</div>
                </DocumentCardDetails>
                {/*<DocumentCardActions*/}
                {/*    actions={[*/}
                {/*        {*/}
                {/*            iconProps: { iconName: 'Delete' },*/}
                {/*            onClick: (ev) => onRemoveFileItemClick(ev, item),*/}
                {/*            ariaLabel: 'Elimina',*/}
                {/*        }*/}
                {/*    ]} />*/}

            </DocumentCard>
        );
    }


    onRenderFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Invia"
                    onClick={this.sendMailPanelSubmit}

                />
                <DefaultButton
                    onClick={this.sendMailPanelDismiss}
                    text="Annulla"
                />
            </React.Fragment>
        );
    }

    render() {
        const { loading, panelIsOpen, messageBarIsVisible, messageBarProps, indicePAPanelIsOpen, rubricaPanelIsOpen, commandBarItems, mailAttachments } = this.state;

        return (
            <Panel
                key='sendMailPanel'

                isLightDismiss
                isOpen={panelIsOpen}
                type={PanelType.custom}
                customWidth={'750px'}
                styles={panelStyles}
                headerText="Spedizione protocollo"
                focusTrapZoneProps={{
                    isClickableOutsideFocusTrap: true,
                    forceFocusInsideTrap: true,
                }}
                onDismiss={this.sendMailPanelDismiss}
                onRenderFooterContent={this.onRenderFooterContent}
                // Stretch panel content to fill the available height so the footer is positioned
                // at the bottom of the page
                isFooterAtBottom={false}

            >
                <CircleLoader loaderClass='loader-large' loading={loading} />

                {
                    messageBarIsVisible &&
                    <MessageBar {...messageBarProps} onDismiss={() => this.setState({ messageBarIsVisible: false })} />
                }

                <div className={"flex flex-column position-relative overflow-hidden"}>
                    <CommandBar
                        overflowButtonProps={overflowProps}
                        items={commandBarItems}
                        styles={commandBarStyles}

                    />

                    <div className={`position-relative my-scroll-div`}>
                        <SendMailForm showMessageError={(errorMessageProps) => this.setState({
                            messageBarIsVisible: true,
                            messageBarProps: errorMessageProps
                        })} dismissMessageError={() => this.setState({ messageBarIsVisible: false })} />
                        <List items={mailAttachments} onRenderCell={this.attachmentRenderCell} style={{ paddingTop: '50px' }} />
                    </div>
                </div>

                {indicePAPanelIsOpen &&
                    <IndicePAPanel
                        indicePAPanelIsOpen={indicePAPanelIsOpen}
                        onIndicePADismiss={this.dismissIncicePALateralPanel}
                        {...this.props}
                    />
                }

                {rubricaPanelIsOpen &&
                    <RubricaPanel
                        rubricaPanelIsOpen={rubricaPanelIsOpen}
                        onRubricaDismiss={this.dismissRubricaLateralPanel}
                        {...this.props}
                    />
                }

            </Panel>

        );
    }
}


export default connector(SendMailPanel);
